module.exports = __webpack_public_path__ + "static/media/logo-saoroberto.44ee2b96.png";